
<section class="ui_contentgroup">
  <div class="contentgroup">
    <div class="contentgroup_top">
      <div class="contentgroup_title">
        <!-- <div class="titleType">{{titleType}}</div> -->
        <div class="left-title">
          
          <div class="title">{{data.name}}</div>
          <div class="contentgroup_date">{{t('__g3p_m8t.__dateCreated')}} : <span>{{date}}</span></div>
        </div>
      </div>
      <div class="iconBlock" @click.stop="openMenu" @keypress.enter="openMenu" :tabindex=" 0">
        <div class="clickSelect">
          {{t('__g3p_m8t.__groupSetting')}} 
          <iCon iconClass="asus_proart_sw_ico_arrow_fill_collapse" :class="[state.modal?'iconshow':'']" class="iconArrow" @click.stop="openMenu" ></iCon>
        </div>
        <!-- <iCon iconClass="asus_proart_sw_ico_settings" class="icon" @click.stop="openMenu" ></iCon> -->
        <div class="contentgroup_littleModal popup"  
        v-click-outside="handleFocusOut"
        :class="[state.modal?'show':'noshow']">
          <div v-for="(e ,i) in settingMenu" class="contentgroup_setting_menu" @click="menuSettingSelect(e)" 
          @keypress.enter="menuSettingSelect(e)" :tabindex=" e.group == 1 ? 0 : -1" >
            <div v-if="e.group == 1" :class="{'isShow': e.group == 1}">{{e.isI18n ? t(e.isI18n) : e.title}}</div>
          </div>
          <hr>
          <div v-for="(e ,i) in settingMenu" class="contentgroup_setting_menu" @click="menuSettingSelect(e)"
          @keypress.enter="menuSettingSelect(e)" :tabindex=" e.group == 2 ? 0 : -1" >
            <div v-if="e.group == 2" :class="{'isShow': e.group == 2}">{{e.isI18n ? t(e.isI18n) : e.title}}</div>
          </div>
        </div>
      </div>
      <!-- <div class="contentgroup_date">
        <span> {{t('__g3p_m8t.__dateCreated')}}：</span>
        <span>{{date}}</span>
      </div> -->
    </div>
    <div class="contentgroup_top contentgroup_bottom ">
      <div class="contentgroup_cellBlock" v-for="(e ,i) in column">
        <div class="mini_title">{{t(e.title)}}</div>
        <div class="mini_text" v-if="typeof state.myData[e.key] != 'object'">
          <span v-if="e.key == 'device_count'" class="fulfill" v-for="(v, i) in fulfill">
            {{v}}
          </span>
          <span class="countText">{{state.myData[e.key]}}</span>
          
        </div>
        <div v-else class="contentgroup_top">
          <div  v-for="(item ,index) in statusData" >
            <div class="mini_text mini_text_24" >
              {{state.myData.connectionsStatus[item.key]}} 
              <span class="mini_title mini_title_white">{{item.title}}</span>
            </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</section>

